import React from 'react'
import './index.less'
import dayjs from "dayjs";
import {symbolMoneyUtil} from '@utils/utils';

class OutDetails extends React.Component {
    constructor(props) {
        super(props)
    }

    render() {
        const {data, } = this.props
        return (
            <div className="out-details mt_14">
                <div className="out-details-item">
                    <div className="details-info-box" data-flex="cross:center">
                        <p className="details-info font-title fw_500 font_14">
                            <span className="mr_8">
                                {__getServerLanguage('DingDan')} {data.orderNumber} 【{data.status}】
                            </span>
                            <span className="con2-txt font_12">{data.createTime?dayjs(data.createTime).format("YYYY-MM-DD HH:mm:ss"):'-'}</span>
                        </p>

                        <p className="details-info font-title fw_500 font_14">
                            <span className="mr_8">
                                {__getServerLanguage('KeHuBianHao')}
                            </span>
                            <span className="con2-txt font_12">
                                <i className="font-title mr_6">{data.buyerNumber}</i>
                                <i>{data.email}</i>
                            </span>
                        </p>
                    </div>
                   {(data.cityName||data.detailedAddress||data.consigneeName||data.consigneeMonde||data.deliveryContactName||data.deliveryContactMobile)?<div className="addressInfo black89 font_12">
                       {(data.cityName||data.countryName)?<p className="black45">
                            {/* 先城市  后国家 DOP不区分语言直接 这样处理*/}
                            {data.cityName||"-"}，<span>{data.countryName||"-"}</span>
                        </p>:null}
                       {data.detailedAddress?<p>{data.detailedAddress}</p>:null}
                        <p className={"fw_700 font_14"}>{data.consigneeName||data.deliveryContactName}</p>
                        <p className={"fw_700 font_14"}>{data.consigneeMonde||data.deliveryContactMobile}</p>
                    </div>:null}
                    <div className="details-item-th con2-txt font_13 mt_10" data-flex="cross:center">
                        <span className="flex1">{__getServerLanguage('ShangPinXinXi')}</span>
                        <span className="pr_28">{__getServerLanguage('XiangShu')}</span>
                    </div>
                    {data.goodItemVOS.map((item, index) => (
                        <div key={index} className="details-goods pr_28" data-flex="cross:top">
                            <img src={item.picUrl} alt=""/>
                            <div className="flex1 ml_12">
                                <p className="font-title lineH_20 mb_8" data-flex="cross:baseline">
                                    <span className="flex1 font_14">
                                        {item.skuName}
                                    </span>
                                    <span className="font_13">x {item.deliveryQuantity}</span>
                                </p>

                                <p className="con2-txt font_12 lineH_18 mb_6" data-flex="cross:baseline">
                                    <span className="flex1">
                                        <span className="mr_24">{__getServerLanguage('ZhuangLiang')}  {item.outboxCapacity}/{__getServerLanguage('WaiXiang')}</span>
                                        <span>{__getServerLanguage('CaiGouJia')}  {symbolMoneyUtil(item.purchasePrice,item.currencySymbol)}</span>
                                    </span>
                                    <span className="font_13">{item.skuOutBoxVolumeTotal} m³</span>
                                </p>

                                <p className="con2-txt font_12 lineH_18" data-flex="cross:baseline">
                                    <span className="flex1">
                                        <span className="mr_24">{__getServerLanguage('TiJi')}  {item.outBoxVolume} m³</span>
                                        <span>{__getServerLanguage('ShangPinBianHao')}  {item.skuNo}</span>
                                     </span>
                                    <span className="font_13">{item.skuGrossWeightTotal} kg</span>
                                </p>
                            </div>
                        </div>
                    ))}

                </div>

                <div className="mt_16 font-title fw_700 font_14 lineH_20" >
                    <p data-flex="main:right">{__getServerLanguage('HeJi')} {data.skuNum} {__getServerLanguage('Kuan')}，{data.quantity} {__getServerLanguage('Xiang')}</p>
                    <p className={"mt_6"} data-flex="main:right"><span className="font_13">{data.outBoxVolumeTotal} m³</span>，<span className="font_13">{data.grossWeightTotal} kg</span></p>
                </div>
            </div>
        )
    }
}

OutDetails.defaultProps = {
    data: {goodItemVOS:[]},
    currencySymbol: '', // 当前币种
}

export default OutDetails


